import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { HeaderMarginTop as Main } from 'legacyComponents/styled/lib';
import styled from 'styled-components';
import { media as oldMedia } from 'legacyComponents/styled/styleUtils';
import { ContentIntro } from 'apps/components/contentIntro';
import { clientStore } from 'apps/client/app';
import { media } from 'styles/utils';
@observer
export class TextPage extends React.Component {
  componentDidMount() {
    clientStore.ScrollToTop();
  }

  render() {
    const { noMargin, title, children } = this.props;
    return (
      <Main noMargin={noMargin}>
        <ContentIntro
          title={title}
          hideButtonWhenSignIn={true}
          variant='primary'
          isCentered
          hasPattern
        />
        <TextWrapper>{children}</TextWrapper>
      </Main>
    );
  }
}

const TextWrapper = styled.div`
  max-width: ${props => `calc(${props.theme.layout.maxWidth} / 2)`};
  padding: ${props => props.theme.layout.paddingInline};
  margin: 0 auto;
  p {
    font-size: ${props => props.theme.font.size.default};
    line-height: 1.5;
    font-style: ${props => props.fontStyle};
  }
  h2 {
    font-size: ${props => props.theme.font.size.medium};
    margin: 32px 0 22px 0;
  }
  h3 {
    margin: 28px 0 18px 0;
  }
  ol {
    padding: ${props => props.theme.spacing.medium};
  }
  li {
    font-size: 1.2em;
    margin-bottom: ${props => props.theme.spacing.default};
  }
  table {
    width: 100%;
    text-align: left;
    border-spacing: 0;
    border: 1px solid ${props => props.theme.color.wfGrey200};
    overflow: hidden;
    margin: ${props => props.theme.spacing.default} 0;
    thead {
      vertical-align: middle;
      border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
      color: ${props => props.theme.color.wfGrey900};
      background-color: ${props => props.theme.color.wfGrey100};
      ${oldMedia.xs`
        display: block;
        overflow-x: auto;
      `};
    }
    th {
      padding: ${props => props.theme.spacing.small};
      background-color: ${props => props.theme.color.wfGrey100};
      border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
      border-right: 1px solid ${props => props.theme.color.wfGrey200};
      text-align: ${props => (props.center ? 'center' : 'left')};
    }
    td {
      padding: ${props => props.theme.spacing.small};
      color: ${props => props.theme.color.wfGrey900};
      text-align: ${props => (props.center ? 'center' : 'left')};
      border-bottom: ${props =>
        props.lastRow ? 'none' : `1px solid ${props.theme.color.wfGrey200}`};
      border-right: 1px solid ${props => props.theme.color.wfGrey200};
    }
    ul {
      font-size: ${props => props.theme.font.size.small};
    }
  }
  /** Media queries */
  ${media.large`
    padding: ${props => props.theme.layout.paddingInline} 0;
    p {
      font-size: ${props => props.theme.font.size.medium};
    }
    h2 {
      font-size: ${props => props.theme.font.size.large};
    }
  `}
`;

export const P = styled.p`
  font-size: ${props => props.theme.spacing.medium};
  line-height: 1.5;
  font-style: ${props => props.fontStyle};
  ${oldMedia.s`
    font-size: 17px;
  `}
`;

export const H2 = styled.h2`
  font-size: ${props => props.theme.spacing.large};
  margin: ${props => props.theme.spacing.medium} 0;
  ${oldMedia.s`
    font-size: 20px;
  `}
`;

export const H3 = styled.h3`
  font-size: ${props => props.theme.spacing.medium};
  ${oldMedia.s`
    font-size: 17px;
  `}
`;

TextPage.propTypes = {
  noMargin: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
};
